export default __webpack_public_path__ + "static/media/ma.1b60d03c.png";